import { memo } from "react";
import { useKeycloak } from "keycloak";

import styles from "./style.module.scss";

function getInitials(userName: string) {
  return userName.split(" ")
    .map(x => x.slice(0, 1))
    .slice(0, 2)
    .join("");
}

export const UserInfo = memo(() => {
  const { tokenData } = useKeycloak();
  const { firstName, lastName, username } = tokenData ?? {};

  const userName =
    [ firstName, lastName ].filter(x => x)
      .join(" ") ||
    username ||
    "Unknown";

  return (
    <>
      <div className={styles.logoContainer}>
        {getInitials(userName)}
      </div>
      {userName}
    </>
  );
});

export default UserInfo;